var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnglandIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#CE1124"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0h5v120h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12h30v5H0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglandIcon);
export default __webpack_public_path__ + "static/media/england_icon.7062d927fdf09e8b6f9fedb5bb73b3b5.svg";
export { ForwardRef as ReactComponent };